module.exports = __webpack_public_path__ + "img/badge_color_spe-mobile.d080ef18.svg";